var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"ae28d4e5f52e1e6d195b6e92ba2aa5cdd8ad86ec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["grey-rooms@hardpixel"]={id:"ae28d4e5f52e1e6d195b6e92ba2aa5cdd8ad86ec"};
      